export const useVisitor = () => {
  const visitorId = useCookie('visitor_id', {
    maxAge: 60 * 60 * 24 * 365 * 10,
    default: () => genUUID()
  })

  return { visitorId }
}
